/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetDeliverFeeOptionsVo } from './GetDeliverFeeOptionsVo';
import {
    GetDeliverFeeOptionsVoFromJSON,
    GetDeliverFeeOptionsVoFromJSONTyped,
    GetDeliverFeeOptionsVoToJSON,
    GetDeliverFeeOptionsVoToJSONTyped,
} from './GetDeliverFeeOptionsVo';

/**
 * 
 * @export
 * @interface ResponseGetDeliverFeeOptionsVo
 */
export interface ResponseGetDeliverFeeOptionsVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseGetDeliverFeeOptionsVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseGetDeliverFeeOptionsVo
     */
    message?: string;
    /**
     * 
     * @type {GetDeliverFeeOptionsVo}
     * @memberof ResponseGetDeliverFeeOptionsVo
     */
    data?: GetDeliverFeeOptionsVo;
}

/**
 * Check if a given object implements the ResponseGetDeliverFeeOptionsVo interface.
 */
export function instanceOfResponseGetDeliverFeeOptionsVo(value: object): value is ResponseGetDeliverFeeOptionsVo {
    return true;
}

export function ResponseGetDeliverFeeOptionsVoFromJSON(json: any): ResponseGetDeliverFeeOptionsVo {
    return ResponseGetDeliverFeeOptionsVoFromJSONTyped(json, false);
}

export function ResponseGetDeliverFeeOptionsVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseGetDeliverFeeOptionsVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : GetDeliverFeeOptionsVoFromJSON(json['data']),
    };
}

export function ResponseGetDeliverFeeOptionsVoToJSON(json: any): ResponseGetDeliverFeeOptionsVo {
    return ResponseGetDeliverFeeOptionsVoToJSONTyped(json, false);
}

export function ResponseGetDeliverFeeOptionsVoToJSONTyped(value?: ResponseGetDeliverFeeOptionsVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': GetDeliverFeeOptionsVoToJSON(value['data']),
    };
}

